import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '../commons/Button';
import { uiActions } from '../../store/ui-slice';

const ConfirmationDialog = () => {
  const dispatch = useDispatch();
  const {
    title,
    message,
    buttonLabel,
    buttonIcon,
    buttonIconPosition,
    buttonAction,
    cancelButtonLabel,
    cancelButtonIcon,
    cancelButtonPosition,
  } = useSelector((p) => p.ui.confirmStatus);

  const handleCloseConfirm = () => {
    dispatch(uiActions.clearConfirmStatus());
  };

  return (
    <div className="app-loader">
      <div className="app-loader-inner -confirm-dialog">
        <h2 className="text-center">{title || '¡Atención!'}</h2>
        <div className="loader-icon" />
        <p className="text-center mb-50">
          {message || 'Necesitas confirmar tu decisión.'}
        </p>
        <div className="buttons">
          <Button
            onClick={handleCloseConfirm}
            label={cancelButtonLabel || 'Cancelar'}
            buttonClasses="-secondary"
            iconPosition={cancelButtonPosition || 'before'}
            iconClasses={cancelButtonIcon || 'times'} />
          <Button
            onClick={buttonAction}
            label={buttonLabel || 'Continuar'}
            iconPosition={buttonIconPosition || 'after'}
            iconClasses={buttonIcon || 'arrow-right'} />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
